import { domains, offers } from '../services/ApiService';
import { domainsConstants } from '../constants/domains';

export const resetDomain = () => ({
  type: domainsConstants.RESET_DOMAIN,
});

export const setDomain = (domain = {}) => ({
  type: domainsConstants.SET_DOMAIN_SUCCESS,
  domain,
});

export const startSetDomain = (domainId, type) => dispatch => {
  dispatch({ type: domainsConstants.SET_DOMAIN_REQUEST });
  return domains
    .getDomain(domainId, type)
    .then((data = { items: [] }) => dispatch(setDomain(data.items[0])));
};

export const addDomain = (data = {}) => ({
  type: domainsConstants.ADD_DOMAIN_SUCCESS,
  ...data,
});

export const startAddDomain = (domain, type) => dispatch => {
  dispatch({ type: domainsConstants.ADD_DOMAIN_REQUEST });
  return domains
    .create(domain, type)
    .then((data = { items: [] }) => dispatch(addDomain(data.items[0])));
};

export const removeDomain = domainId => ({
  type: domainsConstants.REMOVE_DOMAIN_SUCCESS,
  id: domainId,
});

export const editDomain = updates => ({
  type: domainsConstants.EDIT_DOMAIN_SUCCESS,
  updates,
});

export const startEditDomain = (id, type, updates) => dispatch => {
  dispatch({ type: domainsConstants.EDIT_DOMAIN_REQUEST });
  return domains.update(id, type, updates).then(() => dispatch(editDomain(updates)));
};

export const startRemoveDomain = (domainId, type) => dispatch => {
  dispatch({ type: domainsConstants.REMOVE_DOMAIN_REQUEST });
  return domains.delete(domainId, type).then(() => dispatch(removeDomain(domainId)));
};

export const setDomains = (domains = [], count = 0) => ({
  type: domainsConstants.SET_DOMAINS_LIST_SUCCESS,
  domains,
  count,
});

export const startSetDomains = params => dispatch => {
  dispatch({ type: domainsConstants.SET_DOMAINS_LIST_REQUEST });

  return domains
    .getList(params)
    .then((data = {}) => dispatch(setDomains(data.items, data.count)))
    .catch(err => dispatch({ type: domainsConstants.SET_DOMAINS_LIST_FAILURE }));
};

export const setDomainOffer = (offer = {}) => ({
  type: domainsConstants.SET_DOMAIN_OFFER_SUCCESS,
  offer,
});

export const startSetDomainOffer = offerId => dispatch => {
  dispatch({ type: domainsConstants.SET_DOMAIN_OFFER_REQUEST });

  return offers
    .getOfferInfo(offerId)
    .then((data = { items: [] }) => dispatch(setDomainOffer(data.items[0])))
    .catch(err => dispatch({ type: domainsConstants.SET_DOMAIN_OFFER_FAILURE }));
};

export const setDomainSettings = (settings = {}) => ({
  type: domainsConstants.SET_DOMAIN_SETTINGS_SUCCESS,
  settings,
});

export const startSetDomainSettings = () => dispatch => {
  dispatch({ type: domainsConstants.SET_DOMAIN_SETTINGS_REQUEST });
  return domains.getSettings().then(data => dispatch(setDomainSettings(data)));
};

export const startSetDomainReplicaOffersIds = () => dispatch =>
  offers.getList({ categories: 40, limit: 1000, short: 1 }).then(resp => {
    if (resp.items.length > 0) {
      const replicaOffersIds = resp.items.map(_ => _.id);
      dispatch({ type: domainsConstants.SET_DOMAIN_REPLICA_OFFERS_IDS, payload: replicaOffersIds });
    }
  });
